import { api } from '@/services'

export function fetchServiceReport(appointmentId) {
  return api.get(`/web/serviceReport/show/${appointmentId}`)
}

export function fetchServiceReportAsAdmin(appointmentId) {
  return api.get(`/admin/serviceReport/show/${appointmentId}`)
}